import React, { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Logo from '../assets/MALogo.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { jwtDecode } from 'jwt-decode';

// MUST IMPLEMENT TOKEN VERIFICATION AND PASSWORD RESET FUNCTIONALITY LATER BEFORE DEPLOYMENT
// DO NOT CODE FINAL UI VERSION UNTIL BACKEND FUNCTIONALITY IS COMPLETE
const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
//   const userId = searchParams.get('userId');
  const [userId, setUserId] = useState('');
  const [tokenDB, setTokenDB] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [validationErrors, setValidationErrors] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const navigate = useNavigate();

  const apiUrl = process.env.REACT_APP_API_BASE_URL;

  const getDecodedData = () => {
      try {
        if (!token) return null;
        const decoded = jwtDecode(token);
        return {
          token: decoded.token,
          userId: decoded.userId,
        };
    } catch (error) {
        console.error('Invalid token format:', error);
        return null;
    }
  };

  const passwordValidation = () => {
    const errors = [];
  
    if (password !== confirmPassword) {
      errors.push('Passwords do not match');
    }
  
    if (password.length < 8) {
      errors.push('Password must be at least 8 characters long');
    }
  
    if (!/\d/.test(password)) {
      errors.push('Password must contain at least one number');
    }
  
    if (!/[!@#$%^&*]/.test(password)) {
      errors.push('Password must contain at least one special character');
    }
  
    if (!/[A-Z]/.test(password)) {
      errors.push('Password must contain at least one uppercase letter');
    }
  
    if (!/[a-z]/.test(password)) {
      errors.push('Password must contain at least one lowercase letter');
    }
  
    setValidationErrors(errors);
    if (errors.length > 0) {
        return false;
    }
    
    return true;
  };

  const tokenValidation = async () => {

    try {
        const response = await fetch (`${apiUrl}/auth/validate-reset-password-token?token=${tokenDB}&userId=${userId}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        });

        const data = await response.json();

        if (data.success) {
            setEmail(data.data.email);
            return true;
        } else {
            return false;
        }
    } catch (error) {
        console.error('Error validating token:', error);
        return false;
    }
  };


  const handleResetPassword = async (e) => {
    e.preventDefault();

    setIsLoading(true);

    const passwordValid = passwordValidation();
    
    if (!passwordValid) {
        setIsLoading(false);
        return;
    }

    // Call API to reset password here with params userId, email, & new password
    try {
        const response = await fetch(`${apiUrl}/auth/reset-password`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        });

        const data = await response.json();

        if (data.success) {
            setResetSuccess(true);
        } else {
            setValidationErrors([data.message || 'Failed to reset password.']);
        }
        setIsLoading(false);
    } catch (error) {
        setValidationErrors([error.message || 'An error occurred while resetting the password.']);
        setIsLoading(false);
    }
};

const handleVerification = async () => {

    if (!tokenDB || !userId) {
      return;
    }

    const validateToken = async () => {
        const valid = await tokenValidation();
        setTimeout(() => {
            setAuthenticated(valid);
            setIsLoading(false);
        }, 3000); // Simulate loading delay for better UX (3 seconds)
    };
    
    validateToken();
};

    useEffect(() => {
        handleVerification();
    }, [tokenDB, userId]);

    useEffect(() => {
        const decodedData = getDecodedData();
        if (decodedData) {
            setTokenDB(decodedData.token);
            setUserId(decodedData.userId);
        } else {
            setIsLoading(false);
        }
    }, [token]);



    return (
        <div className="wrapper">
            <div className="d-flex justify-content-center" style={{paddingTop: "40px", cursor: "pointer"}} onClick={() => navigate('/')}>
                <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
                <h2 style={{fontWeight: 600}}>Melee Academy</h2>
            </div>
            {authenticated ? (
                !resetSuccess ? (
                    <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                        <div className='d-flex flex-column custom-container'>
                        <h2 className='pb-3 text-center' style={{fontWeight: 400}}>Reset Password</h2>
                        {validationErrors && (
                            <div className="alert bg-danger text-white" role="alert">
                                {validationErrors.map((err) => {
                                    return (
                                        <p key={err} style={{marginBottom: "0px", fontSize: "14px", color: "white"}}>
                                            {err}
                                        </p>
                                    );
                                })}
                            </div>
                        )}
                        <div style={{ position: "relative", marginBottom: "20px" }}>
                            <input
                                className="custom-input rounded"
                                type={showPassword ? "text" : "password"}
                                placeholder="New Password"
                                onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                                onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                style={{
                                    height: "45px",
                                    backgroundColor: "#171A29",
                                    width: "100%", // Ensure the input takes the full width of the container
                                    paddingRight: "40px", // Add padding to make space for the icon
                                    border: "1px solid #3C3E4C",
                                    color: "white",
                                }}
                            />
                            <FontAwesomeIcon
                                icon={showPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                                onClick={() => setShowPassword(!showPassword)} // Toggle password visibility
                                style={{
                                    position: "absolute",
                                    right: "10px", // Position the icon 10px from the right edge of the input
                                    top: "50%", // Center the icon vertically
                                    transform: "translateY(-50%)", // Adjust for vertical centering
                                    cursor: "pointer",
                                    color: "#AEAFBA",
                                    width: "20px",
                                    height: "20px",
                                }}
                            />
                        </div>
                        <div style={{ position: "relative", marginBottom: "20px" }}>
                            <input
                                className="custom-input rounded"
                                type={showConfirmPassword ? "text" : "password"}
                                placeholder="Confirm New Password"
                                onFocus={(e) => (e.target.style.borderColor = "#FFCC19")} // Change border color on focus
                                onBlur={(e) => (e.target.style.borderColor = "#3C3E4C")} // Reset border color on blur
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                style={{
                                    height: "45px",
                                    backgroundColor: "#171A29",
                                    width: "100%", // Ensure the input takes the full width of the container
                                    paddingRight: "40px", // Add padding to make space for the icon
                                    border: "1px solid #3C3E4C",
                                    color: "white",
                                }}
                            />
                            <FontAwesomeIcon
                                icon={showConfirmPassword ? faEyeSlash : faEye} // Toggle between eye and eye-slash icons
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)} // Toggle password visibility
                                style={{
                                    position: "absolute",
                                    right: "10px", // Position the icon 10px from the right edge of the input
                                    top: "50%", // Center the icon vertically
                                    transform: "translateY(-50%)", // Adjust for vertical centering
                                    cursor: "pointer",
                                    color: "#AEAFBA",
                                    width: "20px",
                                    height: "20px",
                                }}
                            />
                        </div>
                        <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600}} disabled={isLoading} onClick={(event) => handleResetPassword(event)}>Reset Password</button>
                    </div>
                    </div>
                ) : (
                    <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                        <div className='d-flex flex-column custom-container'>
                            <h2 className=' text-center' style={{fontWeight: 400}}>Reset Successful</h2>
                            <p className='text-center'>Your password has been successfully reset. You can now log in with your new password.</p>
                            <button className='rounded w-25 mx-auto mt-3' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600}} onClick={() => window.location.href = '/login'}>Login</button>
                        </div>
                    </div>
                )
            ) : 
                isLoading ? (
                    <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                        <div className='d-flex flex-column custom-container text-center'>
                            <div style={{
                                width: '60px',
                                height: '60px',
                                border: '6px solid #f3f3f3',
                                borderTop: '6px solid #FFCC19',
                                borderRadius: '50%',
                                animation: 'spin 1s linear infinite',
                                margin: '0 auto 20px'
                            }}></div>
                            <h2 style={{fontWeight: 400}}>Verifying Token...</h2>
                            <style>{`
                                @keyframes spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    </div>
                ) : (
                    <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                        <div className='d-flex flex-column custom-container'>
                            <h2 className=' text-center' style={{fontWeight: 400}}>Invalid or Expired Token</h2>
                            <p className='text-center'>The password reset link is invalid or has expired. Please request a new password reset.</p>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default ResetPassword;